var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{staticClass:"orderstate-badge",attrs:{"variant":_vm.colorcode}},[[_vm._v(_vm._s(this.label))]],2)}
var staticRenderFns = []

export { render, staticRenderFns }